import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Cart from "./Cart";
import { useCart } from "../context/CartContext";
import { cn } from "../lib/utils";

const PageLayout = ({
  children,
  className,
  contentClassName,
  before,
  showHeader = true,
  showFooter = true,
  showCart = true,
}) => {
  const { isCartOpen } = useCart();

  return (
    <div className={cn("min-h-screen text-foreground", className)}>
      {before}
      <div className={cn("relative z-10", contentClassName)}>
        {showHeader && <Header />}
        {children}
        {showFooter && <Footer />}
      </div>
      {showCart && isCartOpen && <Cart />}
    </div>
  );
};

export default PageLayout;
